export const messages = {
  en: {
    addStaffPrivilege: {
      title: 'Add Privilege',
      privilegeGroup: 'Privilege Group',
      privilege: 'Privilege',
      groupCode: 'Group Code',
      groupName: 'Group Name',
      groupDesc: 'Group Description',
      createTime: 'Create Time',
      privilegeCode: 'Privilege Code',
      privilegeName: 'Privilege Name',
      privilegeDesc: 'Privilege Description',
      close: 'Close',
      submit: 'Submit',
      noSelection: 'No privilege selected',
      selectAll: 'Select All',
      addSuccess: 'Add successfully'
    }
  },
  zh: {
    addStaffPrivilege: {
      title: '添加权限',
      privilegeGroup: '权限组',
      privilege: '权限',
      groupCode: '权限组编码',
      groupName: '权限组名称',
      groupDesc: '权限组描述',
      createTime: '创建时间',
      privilegeCode: '权限编码',
      privilegeName: '权限名称',
      privilegeDesc: '权限描述',
      close: '关闭',
      submit: '提交',
      noSelection: '未选择相应权限',
      selectAll: '全选',
      addSuccess: '添加成功'
    }
  }
}